import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { createNewVehicle, editVehicle } from '../../services/request.service';
import Swal from 'sweetalert2';
import { deleteVehicleToEdit } from '../../reducers/actions/request-actions';

const VehiclesForm = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const vehicle = useSelector((state)=>state.editVehicle.editVehicles)
  const auth = useSelector ((state) => state.auth.user.id);

    const [vehicleData, setVehicleData] = useState({
      letters: vehicle?.letters || "" ,
      numbers: vehicle?.numbers || "",
      documentNumber: vehicle?.documentNumber || "",
      documentType: vehicle?.documentType || "",
      userId: `${auth}`
    });

    const {
      register,
      handleSubmit,
      watch,
      formState: { errors },
    } = useForm();

    const handleInputChange = (e) => {
      setVehicleData({
        ...vehicleData,
        [e.target.name]: e.target.value,
      });
    };

    const handleSave = () =>{
      if(vehicle !== null){
        editVehicle(vehicle.id, vehicleData)
        dispatch(deleteVehicleToEdit())
        setVehicleData({
          letters:"",
          numbers:"",
          documentNumber:"",
          documentType:"",
          userId:`${auth}`
        })
        navigate('/request/vehicles')
      }else{
        createNewVehicle(vehicleData)
        setVehicleData({
          letters: "",
          numbers: "",
          documentNumber: "",
          documentType: "",
          userId: `${auth}`
        })
        dispatch(deleteVehicleToEdit())
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Vehículo guardado',
          showConfirmButton: false,
          timer: 1500
        })
      }
    }

  return (
    <div>
      <form className="row g-3" onSubmit={handleSubmit(handleSave)}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4 className="Request-form-h4">{"Vehículo"}</h4>
          <NavLink to={'/request/vehicles'} className='btn btn-success' onClick={()=>dispatch(deleteVehicleToEdit())} >Mis Vehiculos</NavLink>
        </div>
        <hr className="Request-hr"></hr>
        <div className="mb-3 row">
          <label
            htmlFor="documentType"
            className="col-sm-4 col-form-label"
          >
            Tipo de documento propietario
          </label>
          <div className="col-sm-8">
            <select
              className="form-select"
              name="documentType"
              {...register("documentType", { required: "Seleccione un tipo de documento" })}
              onChange={handleInputChange}
              value={vehicleData.documentType}
            >
              <option value="">Seleccione un tipo de documento</option>
              <option value="CC">Cédula de ciudadanía</option>
              <option value="CE">Cédula de extranjería</option>
              <option value="PA">Pasaporte</option>
            </select>
            {errors?.documentType && (
              <span className="danger">{errors.documentType.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="documentNumber" className="col-sm-4 col-form-label">
            Documento propietario
          </label>
          <div className="col-sm-8">
            <input
              name="documentNumber"
              type="number"
              className="form-control"
              {...register("documentNumber", { required: "Ingrese un numero de documento" })}
              onChange={handleInputChange}
              value={vehicleData.documentNumber}
              placeholder="ej. 1234567890"
            />
            {errors?.documentNumber && (
              <span className="danger">{errors.documentNumber.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="letters" className="col-sm-4 col-form-label">
            Letras
          </label>
          <div className="col-sm-8">
            <input
              name="letters"
              type="text"
              className="form-control"
              {...register("letters", { required: "Ingrese las letras de la placa del vehiculo" })}
              onChange={handleInputChange}
              value={vehicleData.letters}
              placeholder="ej. ABC"
            />
            {errors?.letters && (
              <span className="danger">{errors.letters.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="numbers" className="col-sm-4 col-form-label">
            Números
          </label>
          <div className="col-sm-8">
            <input
              name="numbers"
              type="text"
              className="form-control"
              {...register("numbers", { required: "Ingrese los numeros de la placa del vehiculo" })}
              onChange={handleInputChange}
              value={vehicleData.numbers}
              placeholder="ej. 123"
            />
            {errors?.numbers && (
              <span className="danger">{errors.numbers.message}</span>
            )}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button className="btn btn-success btn-sm">Guardar</button>
        </div>
      </form>
    </div>
  );
}

export default VehiclesForm